import {
  GBI_ANIMAL_FETCH,
  GBI_ANIMAL_FETCH_SUCCESS,
  GBI_ANIMAL_FETCH_FAIL } from './constants';

export const fetchAnimal = id => ({
  type: GBI_ANIMAL_FETCH, id
});
export const fetchAnimalSuccess = (animal, scoreDefinitions) => ({
  type: GBI_ANIMAL_FETCH_SUCCESS, animal, scoreDefinitions
});
export const fetchAnimalFail = (error, id) => ({
  type: GBI_ANIMAL_FETCH_FAIL, error, id
});
